import React from 'react';
import LegacyAccordionSection, { AccordionSectionProps } from './AccordionSection.legacy';
import AlphaAccordionSection from './AccordionSection.alpha';

const Component = process.env.IS_LEGACY ? LegacyAccordionSection : AlphaAccordionSection;
export default Component as React.FC<AccordionSectionProps>;
export type { AccordionSectionProps };
